"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
exports.default = new Network_1.default('bsc-test', [
    new Token_1.default('bnb', 'BNB', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} BNB', 'icon/bnb.svg'),
    new Token_1.default('ether', 'ETH', 'bifi', 1, '0xB3Bb04FdeD40E354d3637c519971e713cae31170', '', false, true, false, [], '{} ETH', 'icon/eth.svg'),
    new Token_1.default('usdt', 'USDT', 'bifi', 2, '0x4D529a9aC211555B99532EfaCa22Db2F3c3e2eFB', '', false, true, false, [], '{} USDT', 'icon/usdt.svg'),
    new Token_1.default('dai', 'DAI', 'bifi', 3, '0x35451ed68eC4B92A458fe128F47E68Cf2fC9221c', '', false, true, false, [], '{} DAI', 'icon/dai.svg'),
    new Token_1.default('usdc', 'USDC', 'bifi', 4, '0x97F493Bd49b8CCdD1d8d5c1B5c0233FaEF9A25f1', '', false, true, false, [], '{} USDC', 'icon/usdc.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0xAF7B8e53A47a23ea71E5c304b898202a277c90C6', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'bnb'),
    new Handler_1.default(1, 'ether'),
    new Handler_1.default(2, 'usdt'),
    new Handler_1.default(3, 'dai'),
    new Handler_1.default(4, 'usdc')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('xBifi.maxBoost', 'getMaxBoost(uint256)', ['handlerID'], ['uint256']),
    new Method_1.default('xBifi.startPosition', 'getStartPosition(uint256,uint256,uint256,uint256)', [
        'srcHandlerID',
        'dstHandlerID',
        'collateralAmount',
        'times',
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.positionNFTs', 'getAllPositionStatus(address)', ['user.address'], ['(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]']),
    new Method_1.default('xBifi.claim', 'getClaimableBifi(address)', ['address'], ['(uint256)[]']),
    new Method_1.default('xBifi.endPosition', 'getEndPosition(address)', ['address'], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)'])
], [
    new EntryPoint_1.default('bifi', '0xd305A424ebE442547FAdEB3C9ae7ab2ee9C2B337'),
    new EntryPoint_1.default('xBifi', '0x08d73E3887e78a130A43445d6d7208ae57BfaAC4'),
    new EntryPoint_1.default('xBifi.factory', '0xeA9e315745aa77f4a351885F68Fb300EeeB828dE')
], 3000);
//# sourceMappingURL=bsc-test.js.map